module.exports = __webpack_public_path__ + "img/undo.94711eeb.svg";